<!--
 * @Author: Gaho
 * @Date: 2024-01-12 13:35:50
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-25 16:57:33
 * @Description: 目前仅用于 Waves 游戏 
-->

<template>
    <div class="one-row">
        <div class="row-left">
            <span class="flex flex-nowrap cursor-pointer"
                @click="jump2TargetCoin(history.pairCurrency)"
            >
                <CurrentCoin
                    class="w-[20px]"
                    :name="history.pairCurrency" 
                ></CurrentCoin>
                <IconSvgUse
                    size="20px"
                    class="up-down-icon shrink-0"
                    :use="history.oTypeColor.icon02"
                    :style="{ color: history.oTypeColor.color }"
                />
            </span>
        </div>
        <!-- 
            左右分界
        -->
        <div class="row-right"
            @click="openDetailModal"
        >
            <!-- ↓ 总押注 -->
            <div >
                <span class="gray-title">
                    <CurrentCoin
                        size="16px"
                        class="mr-1"
                        :name="history.currency"
                    />
                    {{ $t('waves.calc_WagerAmount') }}
                </span>
                <span >
                    <WavesValue
                        :number-value="history.wager" 
                        :coinName="history.currency" 
                        :iTailLong="history.iDecimalPlaces"
                    ></WavesValue>
                </span>
            </div>
            <!-- ↓ 倍数 -->
            <div >
                <span class="gray-title">
                    {{ $t('waves.Multiplier') }} 
                </span>
                <span >
                    x{{ Math.round(history.multi) }} 
                </span>
            </div>
            <!-- ↓ P&L, ROI -->
            <div >
                <span class="gray-title">
                    {{ $t('waves.calc_PL_ROI') }}
                </span>
                <span class="word-warp"> 
                    <em v-if="history.pnl"
                        :style="{ color: history.oPNLColor.color }"
                    >
                        <WavesValue
                            :offsetDistance="'5px'"
                            :number-value="history.pnl" 
                            :coinName="history.currency" 
                            :iTailLong="history.iDecimalPlaces"
                        ></WavesValue>
                        (<WavesValue
                            :suffix="'%'"
                            :offsetDistance="'0px'"
                            :number-value="history.roi"  
                        >
                            <span style="color: var(--Background-Secondary)">
                                ROI
                            </span>
                        </WavesValue>)
                    </em>
                    <template v-else>
                        -
                    </template>
                </span>
            </div>
            <!--
                第一二行分界
            -->
            <!-- ↓ 入场价格 -->
            <div >
                <span class="gray-title">
                    {{ $t('waves.calc_EntryPrice') }}
                </span>
                <span class="word-warp">
                    <WavesValue
                        :number-value="history.entryPrice"
                        :iTailLong="history.precision"
                    ></WavesValue>
                </span>
            </div>
            <!-- ↓ 爆仓价格 -->
            <div >
                <span class="gray-title">
                    {{ $t('waves.calc_BustPrice') }}
                </span>
                <span class="word-warp">
                    <WavesValue
                        :number-value="history.bustPrice"
                        :iTailLong="history.precision"
                    ></WavesValue>
                </span>
            </div>
            <!-- ↓ 出场价格 -->
            <div >
                <span class="gray-title">
                    {{ $t('waves.calc_ExitPrice') }}
                </span>
                <span class="word-warp">
                    <WavesValue
                        :number-value="history.exitPrice"
                        :iTailLong="history.precision"
                    ></WavesValue>
                </span>
            </div>
            <!-- ↓ 出场方式 -->
            <div >
                <span class="gray-title">
                    {{ $t('waves.Status') }}
                </span>
                <span class="word-warp status">
                    <ContractState
                        :state="history.state"
                        :only-icon="false" 
                        :style="{}"
                    ></ContractState>
                </span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import Popper from "vue3-popper";
import WavesValue from '@/pages/casino/futuresGame/_components/wavesValue.vue'; 
import ContractState from "@/pages/casino/futuresGame/_components/contractState.vue"; 
// ==== ↑ 组件 ================ 
import type { WavesHistoryPlus } from '@/socket/game/dto/waves.dto';
import { HistoryTabsEnum } from '@/components/Casino/History/Tabs/ts/Tabs';
import {
    jump2TargetCoin,
    getAfterPnlNetProfit,
    fnGetPriceMoveRate4Coeff,
} from '@/pages/casino/futuresGame/ts/wavesFn'; 
// import { 
//     oTable4Types,
// } from '@/pages/casino/futuresGame/ts/wavesData'; 
import { 
    fnSettingCenter_Ft, 
    settingsState_f,
} from '@/pages/casino/futuresGame/ts/wavesControlCenter'; 

const props = defineProps({
    isMobileMode: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
    history: {
        type: Object as PropType<WavesHistoryPlus>, 
        default: () => ({}),
    },
    tabName: {
        type: String as PropType<HistoryTabsEnum>, 
    },
});

const oSettingCenter = fnSettingCenter_Ft(); 
const emit = defineEmits(['dialogControl','openGameDetail']);

const openDetailModal = () => {
    //  ↓ 游戏详情传值
    const data = {
        data: `futures:${props.history._id}`,
        modal: 'BetDetails',
        wavesType: HistoryTabsEnum.closed,
    }
    emit('openGameDetail',data)
    
    //  ↓ 打开游戏详情，取消跳转事件，改为直接打开游戏详情浮层
    // const {path, query={}} = useRoute();
    // useRouter().push({
    //     replace: true,
    //     path,
    //     query: {
    //         ...query,
    //         data: `futures:${props.history._id}`,
    //         modal: 'BetDetails',
    //         wavesType: HistoryTabsEnum.closed,
    //     },
    // });
};
</script>


<style scoped lang="scss" src="./style/wavesTable.scss"></style>
<style scoped lang="scss">

.one-row{
    .row-right{
        grid-template-rows: auto auto auto;
    }
}


.status{
    display: inline-block;
    margin-left: -3px;
    :deep(){
        svg{
            display: inline-block;
            height: 18px;
            line-height: 18px;
        }
    }
}
</style>

